import {ESmsPricingType} from 'src/containers/TariffsCatalog';

import {EStatus, NONE_SUBSCRIPTION} from './definitions';

export default {
  title: 'Channel registration form',
  subject: 'Sender name',
  subjectHint: "Sender's name in Latin (3 to 11 characters, case-sensitive)",
  subjectFullHint:
    'The name should be unique and accurately identify your company.\n' +
    'Operators may approve or reject the Sender Name. To help approve the name, our manager may request documents from you, such as a trademark certificate, domain or licensing agreement.',
  website: 'Your company website',
  exampleMessage: 'Message text example',
  name: 'Internal channel name',
  nameHint: 'It will appear in the edna Pulse channel list and in the reports',
  subscriptionByOperatorCode:
    'Pricing conditions by operator. See the <0>tariffs summary table</0>',
  subscriptionByOperatorCodeLabel: 'For {{name}} subscribers',
  operatorRuDefault: 'Other operators in Russia',
  operatorRuMegafon: 'Megafon + Skartel (Yota)',
  subscriptionByOperatorCodeLabelRu: 'For subscribers of other operators in Russia',
  subscriptionByOperatorCodeLabelRuHint:
    'Miranda\n' +
    'Rostelecom\n' +
    'MTT\n' +
    'VTB Mobile\n' +
    'TransTeleCom\n' +
    'TatTelecom\n' +
    'Alfa-Mobile\n' +
    'GPB Mobile\n' +
    'Global Telecom\n' +
    'Tinkoff and others',
  clientComment: 'Comment',
  countries: 'Terms of sending messages to subscribers in other countries',
  addCountry: 'Add country',
  countrySubscription: 'Fixed price per message from a dedicated sender name',
  addCountryModal: {
    title: 'Add a country for sending SMS',
    selectCountry: 'Select country',
    submitButton: 'Add country',
  },
  viewForm: {
    subscriptions: 'Sending conditions for this sender',
    countries: 'Terms of sending messages to subscribers in other countries',
    subscriptionsNoTariff: 'Russian operators',
    countriesNoTariff: 'Other countries',
  },
  status: {
    [EStatus.DRAFT]: 'Draft',
    [EStatus.CREATE_SUBJECT]: 'Create subject',
    [EStatus.CREATE_SUBJECT_ERROR]: 'Create subject error',
    [EStatus.IN_PROGRESS]: 'Under consideration',
    [EStatus.REJECTED]: 'Disabled',
    [EStatus.DONE]: 'Correct',
  },
  pricingType: 'Pricing type:',
  setupConditions: 'Set up conditions',
  excludeOperator: 'Exclude operator',
  pricingConditions: 'Pricing conditions',
  excludedPricingType: 'Not billed',
  excludedDescription: "Operator disabled. Messages won't be sent to this operator's numbers.",
  operatorStatus: {
    CONFIGURED: 'Configured',
    EXCLUDED: 'Excluded',
    NOT_CONFIGURED: 'Not configured',
  },
  errors: {
    operatorNotConfigured: 'Set up pricing conditions or exclude the operator',
  },
  excludeOperatorModal: {
    title: 'Exclude operator?',
    subtitle:
      "If you exclude the operator, messages won't be sent to subscribers with numbers of this operator",
    submitButton: 'Disable',
  },
  options: {
    [ESmsPricingType.MAU]: 'Operator pricing',
    [ESmsPricingType.MULTI_MAU]: 'Multi-signature',
    [ESmsPricingType.FEE]:
      'Subscription fee for the client name and price per message as per the price list',
    [ESmsPricingType.MULTI]: 'Fixed price per message from a dedicated sender name',
    [ESmsPricingType.COMMON]: 'Fixed price per message from a shared sender name',
    [ESmsPricingType.FEE_FIX]:
      'Monthly fee for a dedicated sender name and fixed price per message',
    [NONE_SUBSCRIPTION]: "Don't connect",
  },
  optionHints: {
    [ESmsPricingType.MAU]:
      'Messages are sent under the name you entered in this form. A subscription fee is charged monthly regardless of SMS sending. Message prices are calculated according to the tariff.',
    [ESmsPricingType.MULTI_MAU]:
      'Messages are sent under the name you entered in this form. A subscription fee is charged monthly regardless of SMS sending. Message prices are calculated according to the tariff.',
    [ESmsPricingType.FEE]:
      'Messages are sent under the name you entered in this form. A subscription fee is charged based on the number of messages sent. Message prices are calculated according to the tariff.',
    [ESmsPricingType.FEE_FIX]:
      'Messages are sent from the name you specified above. A monthly fee is charged. The price for each SMS is fixed and does not depend on the number of messages sent.',
    [ESmsPricingType.MULTI]:
      'Messages are sent from the name you specified above. There is no monthly fee for the Name. The price for each SMS is fixed and does not depend on the number of messages sent.',
    [ESmsPricingType.COMMON]:
      'Messages are sent from a Shared name, not from the Name you specified above. There is no monthly fee for the Name. The price for each SMS is fixed and does not depend on the number of messages sent.',
    [NONE_SUBSCRIPTION]:
      "You won't be able to send messages to this operator numbers. We won't charge you if you attempt broadcasting to these numbers.",
  },
  subscriptionsMessage: `To register a channel, fill in the form below.<br/> For a list of available operators and connection details, contact your account manager`,
  registrationMessage: `This SMS channel form was sent for registration. You will receive an email when the status changes`,
  channelDisabled: `This channel was disabled by your operator. If you have any questions, contact technical support.`,
};
